import {
  Breadcrumb, BreadcrumbItem, BreadcrumbButton, BreadcrumbDivider,
  Tooltip, makeStyles, tokens,
} from '@fluentui/react-components'
const useStyles = makeStyles({
  breadcrumb: {
    flexWrap: 'wrap',
    rowGap: tokens.spacingVerticalXS,
    minWidth: 0,
  },
  breadcrumbItem: {
    minWidth: 0,
    maxWidth: '100%',
  },
  breadcrumbButton: {
    minWidth: 0,
    maxWidth: '100%',
    borderRadius: tokens.borderRadiusMedium,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground2,
  },
  breadcrumbLabel: {
    display: 'block',
    minWidth: 0,
    maxWidth: '240px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})
import { DocumentFolderRegular } from '@fluentui/react-icons'
import { Fragment } from 'react/jsx-runtime'

import { useWorkspaceExplorer } from './providers/workspaceExplorerProvider'

export default function WorkspaceExplorerBreadcrumb() {
  const styles = useStyles()
  const { workspaceName, breadcrumbs, navigateToBreadcrumb, navigateToRoot } =
    useWorkspaceExplorer()

  return (
    <Breadcrumb size="large" aria-label="Folder path" list={{ className: styles.breadcrumb }}>
      <BreadcrumbItem className={styles.breadcrumbItem}>
        <BreadcrumbButton
          className={styles.breadcrumbButton}
          icon={<DocumentFolderRegular />}
          onClick={breadcrumbs.length === 0 ? undefined : navigateToRoot}
        >
          {workspaceName}
        </BreadcrumbButton>
      </BreadcrumbItem>
      {breadcrumbs.map((folder, index) => (
        <Fragment key={folder.id}>
          <BreadcrumbDivider />
          <BreadcrumbItem className={styles.breadcrumbItem}>
            <Tooltip content={folder.name} relationship="label">
              {index === breadcrumbs.length - 1 ? (
                <span aria-current="page" tabIndex={0} className={styles.breadcrumbLabel}>
                  {folder.name}
                </span>
              ) : (
                <BreadcrumbButton
                  className={styles.breadcrumbButton}
                  onClick={() => navigateToBreadcrumb(index)}
                >
                  <span className={styles.breadcrumbLabel}>{folder.name}</span>
                </BreadcrumbButton>
              )}
            </Tooltip>
          </BreadcrumbItem>
        </Fragment>
      ))}
    </Breadcrumb>
  )
}